import { render, staticRenderFns } from "./scholarshipToForm.vue?vue&type=template&id=5b03795c&scoped=true"
import script from "./scholarshipToForm.vue?vue&type=script&lang=js"
export * from "./scholarshipToForm.vue?vue&type=script&lang=js"
import style0 from "./scholarshipToForm.vue?vue&type=style&index=0&id=5b03795c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b03795c",
  null
  
)

export default component.exports